import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=1f5f4e46&scoped=true&"
import script from "./MenuComponent.vue?vue&type=script&lang=js&"
export * from "./MenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenuComponent.vue?vue&type=style&index=0&id=1f5f4e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f4e46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VListItem,VNavigationDrawer})
